import { render, staticRenderFns } from "./AdminPermissionsSelector.vue?vue&type=template&id=6cf24437&scoped=true"
import script from "./AdminPermissionsSelector.vue?vue&type=script&lang=js"
export * from "./AdminPermissionsSelector.vue?vue&type=script&lang=js"
import style0 from "./AdminPermissionsSelector.vue?vue&type=style&index=0&id=6cf24437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf24437",
  null
  
)

export default component.exports